module.exports = __webpack_public_path__ + "static/2.f2db1e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LowDamage/2.png
// module id = 718
// module chunks = 56660325458610 135966999058180 206171068497285